import { render, staticRenderFns } from "./ponto-de-interesse.vue?vue&type=template&id=14f95f82&scoped=true&"
import script from "./ponto-de-interesse.vue?vue&type=script&lang=js&"
export * from "./ponto-de-interesse.vue?vue&type=script&lang=js&"
import style0 from "./ponto-de-interesse.vue?vue&type=style&index=0&id=14f95f82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f95f82",
  null
  
)

export default component.exports